import { useMutation } from '@apollo/client'
import { AddEventAttendee, AddEventAttendeeVariables } from '../../types'
import { CREATE_EVENT_ATTENDEE } from './operations'

export const useAddAttendee = () =>
  useMutation<AddEventAttendee, AddEventAttendeeVariables>(CREATE_EVENT_ATTENDEE)
